<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="employees"
      :items-per-page="15"
      dense
      item-key="guid"
      elevation="0"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-5">
          <v-toolbar-title>Кассовая смена {{ department.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            hint="Поиск по наименованию, коду, цене"
            persistent-hint
            single-line
            color="orange darken-3"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="orange darken-3"
            icon
            outlined
            small
            @click="$emit('close')"
            class="mr-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.regular="{ item }">
        {{ getRegularSum(item) }}
      </template>
      <template v-slot:item.bonus="{ item }">
        {{ getBonusSum(item) }}
      </template>
      <template v-slot:item.total="{ item }">
        {{ +getRegularSum(item) + +getBonusSum(item) }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-btn :class="getEmployeeEventsStatus(item)==0 ? 'success' : 'warning' ">
          {{ getEmployeeEventsStatus(item) }}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon outlined small color="primary" @click="viewEmployeeEvents(item)">
          <v-icon>mdi-calendar-check</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DepartmentEmployeeEventsTable
      v-if="selectedEmployeeEvents && selectedEmployee"
      :events="selectedEmployeeEvents.events"
      :employee="selectedEmployee"
      :department="department"
      v-on:update-data="viewEmployeeEvents(selectedDepartment)"
      v-on:close="selectedEmployee=null"
    />
  </v-card>
</template>

<script>
import DepartmentEmployeeEventsTable from "@/components/departments/DepartmentEmployeeEventsTable";
export default {
  name: "DepartmentEmployeeTable",
  props: {
    department: Object,
    employees: Array
  },
  components: {DepartmentEmployeeEventsTable},
  data:() => ({
    headers: [
      { text: "ФИО", align: "center", value: "fullname" },
      { text: "Оклад", align: "center", value: "regular" },
      { text: "Бонус", align: "center", value: "bonus" },
      { text: "Заработано", align: "center", value: "total" },
      { text: "Статус", align: "center", value: "status" },
      { text: "Количество дней", align: "center", value: "event_count" },
      { text: "Роль", align: "center", value: "role" },
      { text: "Стаж", align: "center", value: "string_hiredate" },
      { text: "", align: "center", value: "actions" },
    ],
    search: '',
    selectedEmployee: null,
    selectedEmployeeEvents: null,
    selectedDepartment: null,
  }),
  methods: {
    viewEmployeeEvents(item) {
      this.selectedDepartment = item
      this.$api.getEmployeeEventsByDepartmentId(
          {employee_id: item.id, department_id: this.department.id}
      )
      .then(response => {
        this.selectedEmployee = item
        this.selectedEmployeeEvents = response.data
      })
    },
    getRegularSum(item) {
      if (!item.events.length) { return 0}
      return item.events.map((event) => event.regular)
            .reduce((a, b) => +a + +b)
    },
    getBonusSum(item) {
      if (!item.events.length) { return 0}
      return item.events.map((event) => event.bonus)
            .reduce((a, b) => +a + +b)
    },
    getEmployeeEventsStatus(item) {
      let asd = item.events.filter((event) => event.status && !event.is_confirmed)
      return asd.length
    },
  }
}
</script>

<style scoped>

</style>